import { Button, createOruga, Datepicker, Dropdown, Icon, Loading, Modal, Pagination, Table } from '@oruga-ui/oruga-next';
import { bulmaConfig } from '@oruga-ui/theme-bulma';

const oruga = createOruga();

oruga.use(Button);
oruga.use(Datepicker);
oruga.use(Dropdown);
oruga.use(Icon);
oruga.use(Loading);
oruga.use(Modal);
oruga.use(Pagination);
oruga.use(Table);

import '@@/public/scss/main.scss';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(oruga, {
        ...bulmaConfig,
        iconComponent: 'font-awesome-icon',
        iconPack: 'fas',
    })
})
